import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MediaImg from "./MediaImg";
import Reveal from "./Reveal";

export default function BookCard({ book, index = 0 }) {
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <Link
        to={`/buku-karya/${book.slug}`}
        data-testid={`book-card-${book.slug}`}
        className="group flex flex-col h-full bg-surface border border-line rounded-lg overflow-hidden hover:shadow-[0_12px_32px_rgba(32,37,34,0.08)] transition-shadow"
      >
        <MediaImg id={book.cover_id} alt={`Cover ${book.title}`} ratio="3/4">
          <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
            <span className="text-[11px] uppercase tracking-[0.2em] font-semibold text-faint">{book.type}</span>
            <span className="font-serif text-xl text-sub mt-3">{book.title}</span>
          </div>
        </MediaImg>
        <div className="flex flex-col flex-1 p-5">
          <span className="text-[11px] uppercase tracking-[0.18em] font-semibold text-enji">{book.type}</span>
          <h3 className="font-serif text-lg leading-snug mt-2 text-ink flex-1">{book.title}</h3>
          {book.price ? (
            <p className="text-sub text-sm mt-2">{book.price}</p>
          ) : null}
          <span className="inline-flex items-center gap-2 text-sm font-semibold text-enji mt-4">
            Lihat Detail
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
}

